// extracted by mini-css-extract-plugin
export default {"empty":"number_empty__th-v-","nan":"number_nan__KXcKm"};